import { render, staticRenderFns } from "./ClientsNew.vue?vue&type=template&id=6f97496e&scoped=true"
import script from "./ClientsNew.vue?vue&type=script&lang=ts"
export * from "./ClientsNew.vue?vue&type=script&lang=ts"
import style0 from "./ClientsNew.vue?vue&type=style&index=0&id=6f97496e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f97496e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f97496e')) {
      api.createRecord('6f97496e', component.options)
    } else {
      api.reload('6f97496e', component.options)
    }
    module.hot.accept("./ClientsNew.vue?vue&type=template&id=6f97496e&scoped=true", function () {
      api.rerender('6f97496e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/ClientsNew.vue"
export default component.exports